export const HTTP_STATUS = {
  UNAUTHORIZED: 401,
  FORBIDDEN: 403
}
